import { render, staticRenderFns } from "./ClientService.vue?vue&type=template&id=5aaad846&scoped=true"
import script from "./ClientService.vue?vue&type=script&lang=js"
export * from "./ClientService.vue?vue&type=script&lang=js"
import style0 from "./ClientService.vue?vue&type=style&index=0&id=5aaad846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaad846",
  null
  
)

export default component.exports